
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import { IBankBookingFavorite } from "@/models/dossier-configs/bank-config";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	data(){
		return {
			selectedId: 0,
			favorites: DossierConfigService.getBankConfig().Favorites as IBankBookingFavorite[]
		};
	},
	props: {
		label: [String, Object as ()=>TranslateResult],
		fancy: Boolean
	},
	computed: {
		items():ISelectItem<number>[]{
			return this.favorites.map(f=>{
				return {text: f.Name, value: f.ID} as ISelectItem<number>;
			});
		},
		computedLabel():string | TranslateResult{
			return this.label || this.$ct("favorites.label");
		}
	},
	methods: {
		onInput(id:number){
			this.selectedId = id;
			let favorite = this.favorites.find(f=>f.ID == id);
			if (favorite){
				this.$emit("input", favorite);
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
